var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasAction('delete'))?_c('va-action-button',{attrs:{"hide-label":_vm.icon,"label":_vm.$t('va.actions.delete'),"icon":"mdi-trash-can","color":_vm.color || 'red',"text":""},on:{"click":_vm.onDelete}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }